var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgArrowUp = function SvgArrowUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.733 8.142a1 1 0 00.004 1.433l.067.065A1 1 0 008.2 9.637l2.756-2.698L10.969 20A1 1 0 0011.97 21h.122a1 1 0 00.999-1.001l-.014-13.023 2.727 2.645a1 1 0 001.396-.004l.067-.065a1 1 0 00-.004-1.433L11.986 3 6.733 8.142z",
    fill: "#9CA6AD"
  })));
};

export default SvgArrowUp;